import { apiConfiguration } from '../apiConfig';
import { AuthApi, LoginResponseDTO } from '../data';
import { User } from '../types';

export async function signIn(email: string, password: string) {
  try {
    var api = new AuthApi(apiConfiguration);
   
    var response = await api.login({
      loginDTO: {
        username: email,
        password: password
      }
      
    });
        
    return {
      isOk: true,
      data: {
        name: response.name,
        token: response.token
      } as LoginResponseDTO
    };

  }
  catch {
    return {
      isOk: false,
      message: "Authentication failed"
    };
  }
}

export async function getUser() {
  try {
    var api = new AuthApi(apiConfiguration);

    var response = await api.me();

    return {
      isOk: true,
      data: response
    };
  }
  catch {
    return {
      isOk: false,
      data: undefined
    };
  }
}

export async function createAccount(email: string, password: string) {
  try {
    // Send request
    //console.log(email, password);

    return {
      isOk: true
    };
  }
  catch {
    return {
      isOk: false,
      message: "Failed to create account"
    };
  }
}

export async function changePassword(email: string, recoveryCode?: string) {
  try {
    // Send request
    //console.log(email, recoveryCode);

    return {
      isOk: true
    };
  }
  catch {
    return {
      isOk: false,
      message: "Failed to change password"
    }
  }
}

export async function resetPassword(email: string) {
  try {
    // Send request
    //console.log(email);

    return {
      isOk: true
    };
  }
  catch {
    return {
      isOk: false,
      message: "Failed to reset password"
    };
  }
}
